import { html } from "htm/preact";
import { hydrate } from "preact";
import NavItem from "../components/NavItem.js";

const containers = document.querySelectorAll("[data-nav-item]")
if (containers) {
  containers.forEach((container, index) => {
    const btnDiv = container.querySelector("[data-nav-hydrate]")
    if (btnDiv) {
      const text = btnDiv.dataset.btnText;
      const menuDiv = container.querySelector("[data-menu]");

      hydrate(html`<${NavItem} menuDiv=${menuDiv} id=${index} text=${text} btnDiv=${btnDiv} />`, btnDiv);
    }
  })
}